module.exports = __webpack_public_path__ + "static/media/logo.fe977351.webp";